import { render } from "./location.vue?vue&type=template&id=712dba19&scoped=true"
import script from "./location.vue?vue&type=script&lang=js"
export * from "./location.vue?vue&type=script&lang=js"

import "./location.vue?vue&type=style&index=0&id=712dba19&scoped=true&lang=css"

import exportComponent from "D:\\html\\bracelet-management-system\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-712dba19"]])

export default __exports__